import { useCallback } from 'react';
import { extractApiErrorMessage } from '@/lib/error-utils';
import { toast } from '@/hooks';

interface UseHoaDonMuaDichVuMutationProps {
  tableState: MuaHangRecord;
}

export const useHoaDonMuaDichVuMutation = ({ tableState }: UseHoaDonMuaDichVuMutationProps) => {
  const handleEditClick = useCallback(async () => {
    const selectedObj = tableState.selection.selectedObj as MuaHangRecord;
    if (!selectedObj) return;

    tableState.form.handleEditClick();
  }, [tableState.form, tableState.selection.selectedObj]);

  const handleDelete = useCallback(async () => {
    const selectedObj = tableState.selection.selectedObj as MuaHangRecord;
    if (!selectedObj) return;

    try {
      await tableState.crud.deleteItem(selectedObj.uuid);
      tableState.form.handleCloseDelete();
      tableState.selection.clearSelection();
      await tableState.crud.refreshData();
    } catch (error) {
      toast({
        description: extractApiErrorMessage({ data: error }),
        variant: 'destructive'
      });
    }
  }, [tableState.crud, tableState.form, tableState.selection]);

  const handleBulkDelete = useCallback(
    async (uuids: string[]) => {
      try {
        await Promise.all(uuids.map(uuid => tableState.crud.deleteItem(uuid)));
        await tableState.crud.refreshData();
        toast({
          description: 'Đã xóa các hóa đơn mua dịch vụ đã chọn.'
        });
      } catch (error) {
        toast({
          description: extractApiErrorMessage({ data: error }),
          variant: 'destructive'
        });
      }
    },
    [tableState.crud]
  );

  const handleSubmit = useCallback(
    async (data: MuaHangRecord) => {
      const selectedObj = tableState.selection.selectedObj as MuaHangRecord;
      const formMode = tableState.form.formMode;

      try {
        if (formMode === 'add') await tableState.crud.addItem(data);
        else if (formMode === 'edit' && selectedObj) await tableState.crud.updateItem(selectedObj.uuid, data);

        tableState.form.handleCloseForm();
        tableState.selection.clearSelection();
        await tableState.crud.refreshData();
        toast({
          description:
            formMode === 'add'
              ? 'Đã thêm hóa đơn mua dịch vụ thành công.'
              : 'Đã cập nhật hóa đơn mua dịch vụ thành công.'
        });
      } catch (error) {
        toast({
          description: extractApiErrorMessage({ data: error }),
          variant: 'destructive'
        });
      }
    },
    [tableState.crud, tableState.form, tableState.selection]
  );

  return {
    handleEditClick,
    handleDelete,
    handleBulkDelete,
    handleSubmit
  };
};
